<template>
  <component :is="activeComponent"/>
</template>

<script>
  import MRootServicesFindService from './views/m-root-services-find-service';
  import DRootServicesFindService from './views/d-root-services-find-service';

  export default {
    name: "root-services-find-service",
    computed: {
      activeComponent() {
        return this.$isMobile ? MRootServicesFindService : DRootServicesFindService;
      }
    }
  }
</script>

<style scoped>

</style>